import AuthJsForm from "@auth/forms/AuthJsForm";

/**
 * The sign in page.
 */
function SignInPage() {
  return <AuthJsForm formType="signin" />;
}

export default SignInPage;
